import { useTranslation } from "react-i18next";
import { Flex } from "antd";
import { BaseMobileHeader } from "@/common";
import { ProfileForm } from "@/entities/profile-form";
import { ChangeOldPasswordForm } from "@/entities/change-old-password-form";
import { SubscriptionBlock } from "@/entities/subscription-block";
import styles from "./styles.module.scss";

export const SettingsPageMobile = () => {
  const { t } = useTranslation();

  return (
    <Flex className={styles.root} vertical gap={16}>
      <BaseMobileHeader showSorter={false} title={t("common.settings")} />
      <ProfileForm />
      <ChangeOldPasswordForm />
      <SubscriptionBlock />
    </Flex>
  );
};
